// extracted by mini-css-extract-plugin
export default {"text":"ConfirmSavingModal_text__vuj2G","buttonsWrapper":"ConfirmSavingModal_buttonsWrapper__6BJmg"};